import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import Button from '../Button/Button';
import { modalURLFromLocation } from '../../utils/location';
import { useTheme } from '../../../../../ThemeContext';

import styles from './ConfirmationForm.module.scss';

type Props = {
  email?: string;
  loggedIn?: boolean;
  onClickResetPassword: () => void;
};

const ConfirmationForm: React.FC<Props> = ({ email, onClickResetPassword, loggedIn }: Props) => {
  const { t } = useTranslation('account');
  const location = useLocation();
  const { universalStyles } = useTheme();

  return (
    <div className={styles.forgotPasswordForm}>
      <h2 className={styles.title} style={universalStyles.primaryTextColor}>
        {t('reset.check_your_inbox')}
      </h2>
      <p className={styles.text}>
        <span style={universalStyles.neutral400}>{t('reset.link_sent_text')} </span>
        <span style={universalStyles.primaryTextColor}>{email}</span>
      </p>
      <Button
        onClick={onClickResetPassword}
        className={styles.button}
        fullWidth
        color="primary"
        size="exlarge"
        label={t('reset.reset_password_button')}
        textStyle={universalStyles.primaryThemeButtonText}
        style={universalStyles.signUpButton}
      />
      {/* {!loggedIn && (
        <React.Fragment>
          <span className={styles.notSure}>{t('reset.not_sure')}</span>
          <Link className={styles.link} to={modalURLFromLocation(location, 'forgot-password')}>
            {t('reset.try_again')}
          </Link>
        </React.Fragment>
      )} */}
    </div>
  );
};

export default ConfirmationForm;
